import React from 'react';
import { Form, Tooltip, Popconfirm, InputNumber, message, Button } from 'antd';
import ModalDom from '../../../../../components/Modal';
import DetailTitle from '../../../../../components/DetailTitle';
import { CustomRow, CustomCol } from '../../../../../components/Custom';
import { post, postFrom, config } from '../../../../../axios';
import { moneyAddComma, handleDeepCopy } from '../../../../../utils';
import Add from './Add';
import moment from 'moment'
import { backMoneyType } from '../../../../../axios/dictionaries';

class Page extends React.Component {
    constructor() {
        super();
        this.initState = {
            loading: false,
            showAddModal: false,
            data: {},
            turnAway: [],
        };
        this.state = {
            ...handleDeepCopy(this.initState)
        };
    }

    handleCancel = () => { //关闭页面
        this.setState({ ...handleDeepCopy(this.initState) }, () => {
            this.props.handleCancel();
        });
    }

    loadPackage = (id) => {
        this.setState({ loading: true });
        this.billId = id;
        postFrom({ url: config.API_bill_getPayableVo, data: { billId: this.billId } }).then(res => {
            this.setState({ data: res || {}, loading: false });
        }).catch(err => {
            message.error(err.message || '获取详情失败');
            this.setState({ loading: false });
        });
    }

    handleShowAdd = () => {
        this.setState({ showAddModal: true });
        this.addRef.loadPackage(this.state.data.customerId);
    }

    handleOk = () => {
        let { turnAway } = this.state;
        if (turnAway.length) {
            this.setState({ loading: true });
            let values = {};
            values.billId = this.billId;
            values.payOtherBillVoList = turnAway.map(item => ({ billId: item.id, money: item.writeOffMoney }));
            post({ url: config.API_bill_payOtherBill, data: values }).then(res => {
                message.success('转入成功')
                this.handleCancel();
                this.props.handleGetList();
            }).catch(err => {
                message.error(err.message || '转入失败');
                this.setState({ loading: false });
            });
        } else {
            message.error('未选择账单进行操作');
        }
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    render() {
        let { visible, form: { getFieldDecorator } } = this.props;
        let {
            loading,
            showAddModal,
            data,
            turnAway,
        } = this.state;

        let endPayTypes = backMoneyType.find(item => item.value === data.endPayType);

        return <ModalDom
            title="转入收款账单"
            visible={visible}
            loading={loading}
            onOk={this.handleOk}
            onCancel={this.handleCancel}
        >
            <Form>
                <div className="custom">
                    <CustomRow>
                        <CustomCol label="小区/楼栋" required={false}>
                            <span className="not-edit">{data.buildName}</span>
                        </CustomCol>
                        <CustomCol label="房号" required={false}>
                            <span className="not-edit">{data.roomNo}</span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="姓名" required={false}>
                            <span className="not-edit">{data.nowCustomerName}</span>
                        </CustomCol>
                        <CustomCol label="证件号码" required={false}>
                            <span className="not-edit">{data.nowCredentialNumber}</span>
                        </CustomCol>
                        <CustomCol label="手机号码" required={false}>
                            <span className="not-edit">{data.nowCustomerPhone}</span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="可退金额" required={false}>
                            <span className="not-edit">{data.payableMoney}</span>
                        </CustomCol>
                        <CustomCol label="退款原因" required={false}>
                            <span className="not-edit">{data.feeRemark}</span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow>
                        <CustomCol label="应退方式" required={false}>
                            <span className="not-edit">{endPayTypes ? endPayTypes.title : null}</span>
                        </CustomCol>
                        <CustomCol label="账号信息" required={false} colStyle={{ width: '601px' }}>
                            <span className="not-edit">{data.endPayAccount}</span>
                        </CustomCol>
                    </CustomRow>
                </div>
                <DetailTitle title="转入其他合同账单" />
                <div className="custom">
                    <div className="tableBox">
                        <div className="tableTitle">
                            <div style={{ flex: 1 }}>应收日期</div>
                            <div style={{ flex: 1 }}>房源</div>
                            <div style={{ flex: 1 }}>账单名称</div>
                            <div style={{ flex: 1 }}>账单周期</div>
                            <div style={{ flex: 1 }}>应收金额（元）</div>
                            <div style={{ flex: 1 }}>待收金额（元）</div>
                            <div style={{ flex: 1 }}>核销金额（元）</div>
                            <div style={{ flex: '0 0 80px' }}>操作</div>
                        </div>
                        <div className="tableBody">
                            {
                                turnAway.length
                                    ? turnAway.map((item, index) => {
                                        return <div className="tableBodyRow" style={{ textAlign: 'center' }} key={index}>
                                            <div style={{ flex: 1 }}>
                                                <div style={{ padding: '5px', lineHeight: '16px' }}>
                                                    <div style={{ color: "red" }}>{item.overdueDays ? `逾期${item.overdueDays}天` : null}</div>
                                                    <div>{item.mustPayDate ? moment(item.mustPayDate).format('YYYY-MM-DD') : ""}</div>
                                                </div>
                                            </div>
                                            <div style={{ flex: 1 }}>
                                                <div style={{ padding: '5px', lineHeight: '18px' }}>
                                                    <div>{item.roomNo}</div>
                                                    <div>{item.buildingName}</div>
                                                </div>
                                            </div>
                                            <div style={{ flex: 1 }}>
                                                <div style={{ padding: '5px', lineHeight: '18px' }}>
                                                    {item.feeName}
                                                </div>
                                            </div>
                                            <div style={{ flex: 1 }}>
                                                <div style={{ padding: '5px', lineHeight: '18px' }}>
                                                    <div>{item.billBeginDate ? moment(item.billBeginDate).format('YYYY-MM-DD') : null}</div>
                                                    <div>{item.billEndDate ? moment(item.billEndDate).format('YYYY-MM-DD') : null}</div>
                                                </div>
                                            </div>
                                            <div style={{ flex: 1, justifyContent: 'flex-end' }}>
                                                <div style={{ padding: '0 25px', lineHeight: '18px', textAlign: 'right' }}>
                                                    <div>{moneyAddComma(item.billMoney)}</div>
                                                </div>
                                            </div>
                                            <div style={{ flex: 1, justifyContent: 'flex-end' }}>
                                                <div style={{ padding: '0 25px', lineHeight: '18px', color: 'red' }}>
                                                    <div>{moneyAddComma(item.billMoney - item.receivedMoney)}</div>
                                                </div>
                                            </div>
                                            <div style={{ flex: 1 }}>
                                                {getFieldDecorator(`writeOffMoney-${item.id}`)(
                                                    <InputNumber
                                                        style={{ paddingRight: '25px' }}
                                                        className="money-right"
                                                        min={0}
                                                        formatter={value => value !== '' ? value : 0}
                                                        onChange={(value) => {
                                                            turnAway[index].writeOffMoney = value;
                                                            this.setState({ turnAway });
                                                        }}
                                                    />
                                                )}
                                            </div>
                                            <div style={{ flex: '0 0 80px' }}>
                                                <Popconfirm
                                                    placement="topRight"
                                                    title={'此删除操作不可恢复，确定删除吗？'}
                                                    onConfirm={() => {
                                                        let { turnAway } = this.state;
                                                        turnAway.splice(index, 1);
                                                        this.setState({ turnAway });
                                                    }}
                                                    okText="删除"
                                                    cancelText="取消"
                                                >
                                                    <span className="showClickDetail">删除</span>
                                                </Popconfirm>
                                            </div>
                                        </div>
                                    })
                                    : <div className="tableBodyRow" style={{ height: '34px', lineHeight: '34px', justifyContent: 'center', color: '#888' }}>暂无数据！</div>
                            }
                            <div className="tableBodyRow" style={{ justifyContent: 'space-between', alignItems: 'center', height: '34px', padding: '0 35px 0 20px' }}>
                                <span>核销金额合计：<span style={{ color: 'red' }}>{moneyAddComma(turnAway.reduce((total, item) => total + item.writeOffMoney || 0, 0))}</span>元</span>
                                <Tooltip placement="bottomLeft" title={"添加合同账单"}>
                                    <Button onClick={this.handleShowAdd} style={{ width: '24px', height: '24px', lineHeight: '16px', fontSize: '14px' }} shape="circle" icon="plus" />
                                </Tooltip>
                            </div>
                        </div>
                    </div>
                </div>
                <Add
                    onRef={ref => this.addRef = ref}
                    visible={showAddModal}
                    handleCancel={() => { this.setState({ showAddModal: false }) }}
                    setList={(value) => { value = value.map(item => { item.writeOffMoney = 0; return item }); this.setState({ turnAway: value }) }}
                />
            </Form>
        </ModalDom>
    }
}

export default Form.create()(Page);


// WEBPACK FOOTER //
// ./src/page/Bill/components/Payment/TurnAway/index.js